export default {"src":"/_next/static/media/icon-cloud.da666ea0.svg","height":44,"width":42,"blurWidth":0,"blurHeight":0};